// extracted by mini-css-extract-plugin
export var content = "Testimonials-module--content--a671d";
export var counter = "Testimonials-module--counter--12db9";
export var fadeInAnimation = "Testimonials-module--fadeInAnimation--439da";
export var footer = "Testimonials-module--footer--df41d";
export var header = "Testimonials-module--header--7c3e1";
export var link = "Testimonials-module--link--4cc0f";
export var sections = "Testimonials-module--sections--7bcce";
export var tabButtons = "Testimonials-module--tabButtons--1d0b1";
export var wrapper = "Testimonials-module--wrapper--4f4bd";